// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.
import { useCurrentScenarioId } from '../../../../state/hooks/ScenarioHooks';
import { useGetAgingLawsByScenario, useGetTechVar } from '../../../../state/wizard/WizardHooks';
import useWizardState from '../../useWizardState';

export const useFamilleEquipements = () => {
  const scenarioId = useCurrentScenarioId();
  const agingLaws = useGetAgingLawsByScenario(scenarioId);
  const equipmentFamily = useGetTechVar('familleEquipement', scenarioId);
  const { curvePoints, setCurvePoints } = useWizardState();

  const savedPoints = curvePoints[equipmentFamily];
  const savePoints = (points) => {
    setCurvePoints((prev) => ({
      ...prev,
      [equipmentFamily]: points,
    }));
  };

  return {
    agingLaws,
    equipmentFamily,
    scenarioId,
    savedPoints,
    savePoints,
  };
};
